import { render, staticRenderFns } from "./ImageObjectCardSectionPropertiesDefaultSlot.vue?vue&type=template&id=a4f26e7c&scoped=true&"
import script from "./ImageObjectCardSectionPropertiesDefaultSlot.vue?vue&type=script&lang=js&"
export * from "./ImageObjectCardSectionPropertiesDefaultSlot.vue?vue&type=script&lang=js&"
import style0 from "./ImageObjectCardSectionPropertiesDefaultSlot.vue?vue&type=style&index=0&id=a4f26e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f26e7c",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
